import { render, staticRenderFns } from "./AdminLab.vue?vue&type=template&id=ebd8e932&scoped=true"
import script from "./AdminLab.vue?vue&type=script&lang=js"
export * from "./AdminLab.vue?vue&type=script&lang=js"
import style0 from "./AdminLab.vue?vue&type=style&index=0&id=ebd8e932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd8e932",
  null
  
)

export default component.exports